module.exports = __webpack_public_path__ + "img/about_num4.21fe5f4.png";